import { CompanyAccountPage } from "@/features/company/pages/CompanyAccount";

const CompanyAccount = () => {
  return <CompanyAccountPage />;
};

export default CompanyAccount;
